import React from 'react';
import './styles.scss';
import useAnalytics from './hooks';
import Stepper from '../../../components/molecules/steppers';
import Form from '../../../components/molecules/forms';
import RenderChartTotal from './renderChartTotal';
import RenderChartClient from './renderChartClient';
import RenderChartRoute from './renderChartRoute';
import LandingHeader from '../../../components/layout/header/landing';

function Analytics() {
  const {
    setStep, step, vm, route, client,
  } = useAnalytics();

  return (
    <div className="py-4">
      <LandingHeader title="Analytics" />
      <div className="px-4 px-xl-5">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Stepper.Slide
              step={step}
              setStep={setStep}
              labels={['All', 'Routes', 'Clients']}
            />
          </div>
          <div className={step === 1 ? 'col-xl-9 col-lg-8 col-md-6 col-sm-12 mb-md-0 mb-4' : 'd-none'}>
            <Form.ReactSelect.Default
              id="routeSelect"
              placeholder="Choose Route"
              isTextIcon
              options={route.list}
              value={route.current}
              onChange={route.setCurrent}
              disabled={route.load}
            />
          </div>
          <div className={step === 2 ? 'col-xl-9 col-lg-8 col-md-6 col-sm-12 mb-4' : 'd-none'}>
            <div className="row">
              <div className="col-lg-6 mb-lg-0 mb-2">
                <Form.ReactSelect.Default
                  id="clientSelect"
                  placeholder="Choose Client"
                  isTextIcon
                  options={client.list}
                  value={client.current}
                  onChange={client.setCurrent}
                  disabled={client.load}
                />
              </div>
              <div className="col-lg-6">
                <Form.ReactSelect.Default
                  id="vmSelect"
                  placeholder="Vending Machine"
                  isSearchable={false}
                  value={vm.current}
                  onChange={vm.setCurrent}
                  options={vm.list}
                  disabled={client.load}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={step === 0 ? 'w-100' : 'd-none'}>
          <RenderChartTotal />
        </div>
        <div className={step === 1 ? 'w-100' : 'd-none'}>
          <RenderChartRoute currentRoute={route.current} />
        </div>
        <div className={step === 2 ? 'w-100' : 'd-none'}>
          <RenderChartClient currentClient={client.current} currentVm={vm.current} />
        </div>
      </div>
    </div>
  );
}

export default Analytics;
